<template>
  <div class="chart-box">
    <svg :viewBox="`0 0 ${W} ${H}`" class="chart" @mouseleave="hover = null">
      <g v-for="(it, i) in items" :key="it.key" @mouseenter="hover = it">
        <rect :x="0" :y="rowY(i) - rowH / 2" :width="W" :height="rowH" fill="transparent" />
        <text :x="PAD.l - 12" :y="rowY(i) + 4" class="row-label" text-anchor="end">{{ it.label }}</text>
        <!-- worse side (pink, left of zero) — only for two-sided levers -->
        <rect
          v-if="!it.oneSided"
          :x="x(-Math.abs(it.impact))" :y="rowY(i) - barH / 2"
          :width="x(0) - x(-Math.abs(it.impact))" :height="barH" class="bar-worse"
          :opacity="dim(it)"
        />
        <!-- better side (black, right of zero) -->
        <rect
          :x="x(0)" :y="rowY(i) - barH / 2"
          :width="x(Math.abs(it.impact)) - x(0)" :height="barH" class="bar-better"
          :opacity="dim(it)"
        />
        <text :x="x(Math.abs(it.impact)) + 8" :y="rowY(i) + 4" class="value-label">{{ fmtM(Math.abs(it.impact)) }}</text>
      </g>
      <line :x1="x(0)" :x2="x(0)" :y1="PAD.t - 8" :y2="H - PAD.b + 2" class="zero" />
      <text :x="PAD.l" :y="H - 8" class="axis-note" text-anchor="start">worse</text>
      <text :x="x(0)" :y="H - 8" class="axis-note" text-anchor="middle">2027 result {{ fmtM(centerValue) }}</text>
      <text :x="W - PAD.r" :y="H - 8" class="axis-note" text-anchor="end">better</text>
    </svg>
    <p class="reading" :class="{ 'reading-quiet': !hover }">
      <template v-if="hover"><b>{{ hover.label }}</b> — {{ fmtM(Math.abs(hover.impact)) }} on the 2027 result; {{ hover.note }}.</template>
      <template v-else>Hover a bar for detail.</template>
    </p>
  </div>
</template>

<script>
import { scaleLinear } from '../../utils/chartUtils';
import { formatM } from '../../utils/boardEngine';

export default {
  name: 'TornadoChart',
  props: {
    items: { type: Array, required: true }, // [{key,label,impact,note,oneSided?}]
    centerValue: { type: Number, default: 0 },
  },
  data: () => ({ W: 1000, PAD: { l: 250, r: 90, t: 16, b: 30 }, rowH: 38, barH: 14, hover: null }),
  computed: {
    H() { return this.PAD.t + this.items.length * this.rowH + this.PAD.b; },
    maxAbs() { return Math.max(...this.items.map((i) => Math.abs(i.impact))) || 1; },
    x() { return scaleLinear([-this.maxAbs, this.maxAbs], [this.PAD.l, this.W - this.PAD.r]); },
  },
  methods: {
    fmtM: formatM,
    rowY(i) { return this.PAD.t + i * this.rowH + this.rowH / 2; },
    dim(it) { return this.hover && this.hover !== it ? 0.5 : 1; },
  },
};
</script>

<style scoped>
.chart-box { position: relative; }
.chart { width: 100%; height: auto; display: block; }
.zero { stroke: var(--paper); stroke-width: 2; }
.row-label { font-size: 12.5px; font-weight: 700; fill: var(--ink); }
.value-label { font-size: 12.5px; font-weight: 700; fill: var(--ink); font-variant-numeric: tabular-nums; }
.axis-note { font-size: 10.5px; fill: var(--muted); }
.bar-better { fill: var(--ink); }
.bar-worse { fill: var(--pink); }
.reading { font-size: 12px; color: var(--ink); margin: 2px 0 0; min-height: 18px; }
.reading-quiet { color: var(--muted); }
</style>
